export default "__VITE_ASSET__vWjjp0sK__"